<template>
  <div v-click-outside="onClickOutside" class="tq-person-selector-search">
    <el-popover
      placement="bottom"
      popper-class="tq-person-selector-search-popper"
      :width="500"
      :show-arrow="false"
      :teleported="false"
      :visible="popoverVisible"
    >
      <template #reference>
        <tq-search-input
          v-model="hookData.keyword"
          clearable
          placeholder="搜索工号、姓名、部门"
          :width="500"
          @focus="popoverVisible = true"
        ></tq-search-input>
      </template>
      <el-scrollbar v-loading="hookData.searchLoading" max-height="238px">
        <checkbox-radio
          v-show="hookData.searchPersonList.length"
          v-model="hookData.selectedCodes"
          v-infinite-scroll="onLoadMore"
          :multiple="multiple"
          :max-width="420"
          :keyword="hookData.keyword"
          :data="hookData.searchPersonList"
          :infinite-scroll-disabled="isDisabled || hookData.searchLoading"
        ></checkbox-radio>
        <p
          v-show="isDisabled && hookData.searchPersonList.length"
          class="tq-person-selector-search-tip"
        >
          ———— 到底啦，没有更多数据了 ————
        </p>
      </el-scrollbar>
      <Empty
        v-show="!hookData.searchPersonList.length"
        v-loading="hookData.searchLoading"
        :text="'暂无结果，请重新输入'"
        :top="55"
      ></Empty>
    </el-popover>
  </div>
</template>

<script lang="ts" setup>
import Empty from "./Empty.vue";
import checkboxRadio from "./checkboxRadio.vue";
import { ref, inject, computed } from "vue";
import { ClickOutside as vClickOutside } from "element-plus";
import { hookData, isDisabled, onLoadMore } from "../hooks/index";

const emits = defineEmits(["clickOutside"]);

const popoverVisible = ref<boolean>(false);

const multiple = inject<boolean>("multiple")!;

const minHeight = computed(() =>
  hookData.searchPersonList.length === 1 ? "64px" : "160px"
);
const onClickOutside = () => (popoverVisible.value = false);
</script>

<style>
.tq-person-selector-search .tq-person-selector-search-popper {
  min-height: v-bind(minHeight);
}
</style>